export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13608.908db534.jpg";